import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const AddIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M19 11h-6V5c0-.5-.5-1-1-1a1 1 0 0 0-1 1v6H5a1 1 0 0 0-1 1c0 .5.5 1 1 1h6v6c0 .5.5 1 1 1s1-.5 1-1v-6h6c.5 0 1-.5 1-1s-.4-1-1-1Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default AddIcon;
